import { NavGroup } from '../models/nav.model';

export const NAV_MENU: NavGroup[] = [{
	group: 'Operating System',
	items: [{
		href: '/',
		icon: 'grid',
		label: 'Command Center',
		permission: ['JOB_VIEW']
	},
		// { href: '/ledger',               icon: 'ledger', label: 'Digital Ledger' },
		// { href: '/606-dashboard',        icon: 'pie',    label: 'SEC Rule 606 Dashboard' },
	]
}, {
	group: 'Financial Operations',
	items: [{
		/** Jobs, Results and My Exports are tabs inside this one module. */
		href: '/reconciliation',
		icon: 'flow',
		label: 'Reconciliation',
		permission: ['RECON_VIEW']
	}]
}, {
	group: 'Access Management',
	permission: ['TENANT_VIEW', 'USER_VIEW', 'ROLE_VIEW', 'PERMISSION_VIEW', 'TENANT_CONFIG_VIEW', 'BRANDING_VIEW'],
	items: [{
		href: '/access-management/tenant/list',
		icon: 'building',
		label: 'Tenant List',
		permission: ['TENANT_VIEW'],
		/** Platform-only: require TENANT_VIEW with PLATFORM in dmp_permission_scopes. */
		scopes: ['PLATFORM'],
	}, {
		href: '/access-management/tenant-config/list',
		icon: 'ops',
		label: 'Tenant Config',
		permission: ['TENANT_CONFIG_VIEW'],
		scopes: ['PLATFORM'],
	}, 
	/* {
		href: '/access-management/branding/list',
		icon: 'spark',
		label: 'Branding',
		permission: ['BRANDING_VIEW'],
	}, */
	 {
		href: '/access-management/users/list',
		icon: 'users',
		label: 'User List',
		permission: ['USER_VIEW']
	}, {
		href: '/access-management/role/list',
		icon: 'shield',
		label: 'Role List',
		permission: ['ROLE_VIEW']
	}, {
		href: '/access-management/permissions/list',
		icon: 'lock',
		label: 'Permissions List',
		permission: ['PERMISSION_VIEW']
	}]
}];
